let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
// In dark mode, alerts inherit light surface text but have light backgrounds — override to fix contrast
const StyledGlobalAlertOverrides = createGlobalStyle(_t || (_t = _`
  [role="alert"]:not([data-alert-type="banner"]):not([data-alert-type="tip"]) {
    color: ${0} !important;
  }
`), ({
  theme
}) => theme.color['text-alert-default']);
export const GlobalAlertStyles = () => {
  return /*#__PURE__*/_jsx(StyledGlobalAlertOverrides, {});
};